import { ReactNode } from 'react';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

export type SortableLabelProps = {
  id: string;
  children: ReactNode;
  dataTour?: string;
  isSelected?: boolean;
  onClick?: () => void;
};

export const SortableLabel = ({
  id,
  children,
  dataTour,
  isSelected,
  onClick,
}: SortableLabelProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      onClick={onClick}
      className={`group relative h-full cursor-pointer overflow-hidden rounded-lg ${isDragging ? 'z-50 opacity-50' : ''} ${isSelected ? 'ring-2 ring-blue-400' : ''}`}
    >
      <div
        {...listeners}
        {...attributes}
        data-tour={dataTour}
        className="absolute inset-y-0 left-0 z-10 flex w-6 cursor-grab touch-none items-center justify-center rounded-l-lg border-r border-gray-200 bg-gray-100 transition-all hover:bg-gray-200"
      >
        <div className="flex flex-col gap-[3px]">
          <div className="flex gap-[3px]">
            <div className="h-1 w-1 rounded-full bg-gray-400" />
            <div className="h-1 w-1 rounded-full bg-gray-400" />
          </div>
          <div className="flex gap-[3px]">
            <div className="h-1 w-1 rounded-full bg-gray-400" />
            <div className="h-1 w-1 rounded-full bg-gray-400" />
          </div>
          <div className="flex gap-[3px]">
            <div className="h-1 w-1 rounded-full bg-gray-400" />
            <div className="h-1 w-1 rounded-full bg-gray-400" />
          </div>
        </div>
      </div>
      {children}
    </div>
  );
};
